import { Box } from '@mui/material';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { RiArrowLeftDoubleLine, RiArrowRightDoubleLine } from 'react-icons/ri';

const PrevNextButton = ({ type = 'prev' | 'next' }) => (
	<Box>
		{isMobile ? (
			type === 'prev' ? (
				<RiArrowLeftDoubleLine size={20} color="#066BFB" />
			) : (
				<RiArrowRightDoubleLine size={20} color="#066BFB" />
			)
		) : type === 'prev' ? (
			'Prev'
		) : (
			'Next'
		)}
	</Box>
);

export const PrevButtonFunc = () => <PrevNextButton type="prev" />;
export const NextButtonFunc = () => <PrevNextButton type="next" />;

export default PrevNextButton;
